import { Injectable } from '@angular/core';
import { Client, StompSubscription } from '@stomp/stompjs';

@Injectable({
  providedIn: 'root',
})
export class WebsocketService {
  public client: Client;
  private subscriptions: { [key: string]: StompSubscription } = {};

  constructor() {
    this.client = new Client({
      brokerURL: 'wss://iot-core-dev.cochabamba.bo/ws'
    });

    this.client.onConnect = () => {
      console.log('Connected');
    };

    this.client.onDisconnect = () => {
      console.log('Disconnected');
    };
  }

  public connect(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.client.onConnect = () => {
        resolve();
      };
      this.client.onStompError = (frame) => {
        console.error('Broker reported error: ' + frame.headers['message']);
        console.error('Additional details: ' + frame.body);
        reject(frame);
      };
      this.client.activate();
    });
  }

  public subscribeToTopic(topic: string, callback: (message: any) => void) {
    if (!this.client.connected) {
      console.error('Client is not connected. Please connect first.');
      return;
    }

    if (!this.subscriptions[topic]) {
      this.subscriptions[topic] = this.client.subscribe(topic, (message) => {
        callback(message.body);
      });
      console.log(`Subscribed to topic: ${topic}`);
    }
  }

  public disconnect() {
    if (this.client) {
      Object.values(this.subscriptions).forEach(sub => sub.unsubscribe());
      this.client.deactivate();
      console.log('Disconnected');
    }
  }
}
